import React from 'react';
import './style.scss';
var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    subLabel = _ref.subLabel,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "Checkbox GoogleConsentCookieBanner__checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "Checkbox__input",
    name: name,
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "icon-before icon-checkmark"
  }, label, " ", /*#__PURE__*/React.createElement("span", null, subLabel)));
};
export default Checkbox;